export default __webpack_public_path__ + "static/media/qa.8b7d90d4.svg";